// extracted by mini-css-extract-plugin
module.exports = {"messageOrigin":"styles_messageOrigin__2lrN9","messageSender":"styles_messageSender__1Qaxa"};